import OverviewCommunityAmenities from "entities/Deal/components/OverviewCommunityAmenities";
import { IMemoSection } from "entities/Memo/sdk";

const SectionCommunityAmenities = ({
  dealId,
  externalToken,
  section,
  onUpdate,
}: {
  dealId: number;
  externalToken?: string;
  section?: IMemoSection;
  onUpdate?: () => void;
}) => (
  <OverviewCommunityAmenities
    dealId={dealId}
    externalToken={externalToken}
    section={section}
    onUpdate={onUpdate}
    displayImage={section?.amenities_section_display_image}
  />
);

export default SectionCommunityAmenities;
